import { render, staticRenderFns } from "./userRegister.vue?vue&type=template&id=c24aab3c&scoped=true&"
import script from "./userRegister.vue?vue&type=script&lang=js&"
export * from "./userRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24aab3c",
  null
  
)

export default component.exports